import { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Modal,
  Form,
  Radio,
  Col,
  Select,
  Row,
  Tabs,
  Checkbox,
  DatePicker,
  TimePicker,
  Input,
  Space,
} from "antd";
import { CalendarOutlined, ClockCircleOutlined } from "@ant-design/icons";
import moment from "moment";
import dayjs from "dayjs";
import { use } from "react";
import {
  CreateTechLeaveApi,
  getAppointmentCountByStatusId,
  getAppointmentsByDate,
} from "./DispatchApi";

const ScheduleLeave = (props) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const now = dayjs();
  //const [form] = Form.useForm();
  const [formLeave] = Form.useForm();
  const companyId = localStorage.getItem("CompanyId");

  const [selectedFromDate, setSelectedFromDate] = useState(null);
  const [selectedToDate, setSelectedToDate] = useState(null);
  const [multipleDays, setMultipleDays] = useState(false);
  const [selectedFromTime, setSelectedFromTime] = useState(null);
  const [selectedEndTime, setSelectedEndTime] = useState(null);
  const techniciansList = useSelector((state) => state.lookup.technicians);

  const handleFromTimeChange = (time) => {
    setSelectedFromTime(time);

    if (time) {
      const calculatedToTime = dayjs(time).add(60, "minute");
      formLeave.setFieldsValue({ toTime: calculatedToTime });
      //formLeave.validateFields(["toTime"]);
    }
  };

  const handleFromDateChange = (date) => {
    setSelectedFromDate(date);

    if (date) {
      formLeave.setFieldsValue({ toDate: date });
      setSelectedToDate(date);
    }
  };

  const onMultipledayCheckChange = (e) => {
    const isChecked = e.target.checked;
    setMultipleDays(isChecked);
    if (!isChecked) {
      formLeave.setFieldsValue({ toDate: selectedFromDate });
    }
  };

  const handleSubmit = async () => {
    try {
      const formData = await formLeave.validateFields();
      const fromDate = dayjs(formData?.fromDate).format("YYYY-MM-DD");
      const toDate = dayjs(selectedToDate).format("YYYY-MM-DD");
      let fromTime, toTime;

      if (multipleDays) {
        fromTime = dayjs("00:00", "HH:mm").set("second", 0);
        toTime = dayjs("23:59", "HH:mm").set("second", 0);
      } else {
        fromTime = dayjs(formData?.fromTime).set("second", 0);
        if (
          formData?.toTime &&
          dayjs(formData?.toTime).format("HH:mm") === "00:00"
        ) {
          toTime = dayjs("23:59", "HH:mm").set("second", 0);
        } else {
          toTime = dayjs(formData?.toTime).set("second", 0);
        }
      }

      const formattedData = {
        employeeId: props?.initialValues?.techId,
        companyId: companyId,
        startTime: fromTime.format("HH:mm:ss"),
        endTime: toTime.format("HH:mm:ss"),
        startDate: fromDate,
        endDate: toDate,
        unavailabilityReason: formData.notes,
      };

      dispatch(
        CreateTechLeaveApi(formattedData, props?.initialValues?.selectedDate)
      ).then((res) => {
        if (res) {
          props?.initialValues?.onCancel();
        }
        dispatch(
          getAppointmentsByDate({
            startDate: props?.initialValues?.selectedDate.format("YYYY-MM-DD"),
            pageNo: 1,
            pageSize: 24,
          })
        );
        dispatch(
          getAppointmentCountByStatusId(
            props?.initialValues?.selectedDate.format("YYYY-MM-DD")
          )
        );
      });
    } catch (error) {
      console.error("Validation failed:", error);
    }
  };

  useEffect(() => {
    if (props?.initialValues) {
      const parsedTime = dayjs(props.initialValues.time, "HH:mm");
      handleFromTimeChange(parsedTime);

      const appointmentDate = dayjs(
        props.initialValues.selectedDate,
        "YYYY-MM-DD"
      );
      handleFromDateChange(appointmentDate);

      formLeave.setFieldsValue({
        fromTime: parsedTime,
        fromDate: appointmentDate,
      });
    }
  }, []);

  useEffect(() => {
    const Tech = techniciansList?.find(
      (tech) => tech.id === props?.initialValues?.techId
    );

    if (Tech) {
      formLeave.setFieldsValue({
        staffId: `${Tech.firstName} ${Tech.lastName}`,
      });
    }
  }, [techniciansList]);

  return (
    <div className="">
      <Form name="basic" layout="vertical" form={formLeave} size="large">
        <Form.Item name="id" hidden={true}></Form.Item>
        <Row
          gutter={16}
          align="middle"
          justify="start"
          className="appointment-top scheduleleave"
        >
          <Col>
            <div>
              <Form.Item>
                <Checkbox
                  name="appointmentDate"
                  onChange={(e) => onMultipledayCheckChange(e)}
                >
                  <FormattedMessage id="Dispatch.CustomDates" />
                </Checkbox>
              </Form.Item>
            </div>
          </Col>
          <Col>
            <div className="appoint-block-new">
              <Form.Item
                name="fromDate"
                rules={[
                  {
                    required: true,
                    message: "Select appointment date",
                  },
                  {
                    validator: (_, value) => {
                      if (!value) {
                        return Promise.resolve();
                      }
                      if (value.isBefore(now, "day")) {
                        return Promise.reject(
                          new Error("Selected date cannot be in the past")
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                {/* <CalendarOutlined className="customicon" /> */}
                <DatePicker
                  prefix={<CalendarOutlined className="customicon" />}
                  suffixIcon={null}
                  placeholder="Select Date"
                  variant="borderless"
                  allowClear={false}
                  disabledDate={(current) =>
                    current && current < moment().startOf("day")
                  }
                  onChange={(date) => handleFromDateChange(date)}
                />
              </Form.Item>
            </div>
          </Col>
          {multipleDays && (
            <Col>
              <div className="appoint-block-new">
                <Form.Item
                  name="toDate"
                  rules={[
                    {
                      required: true,
                      message: "Select appointment date",
                    },
                    {
                      validator: (_, value) => {
                        if (!value) {
                          return Promise.resolve();
                        }
                        if (value.isBefore(now, "day")) {
                          return Promise.reject(
                            new Error("Selected date cannot be in the past")
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  {/* <CalendarOutlined className="customicon" /> */}
                  <DatePicker
                    prefix={<CalendarOutlined className="customicon" />}
                    suffixIcon={null}
                    placeholder="Select Date"
                    variant="borderless"
                    allowClear={false}
                    disabledDate={(current) => {
                      if (!current) return false;

                      // disable past dates
                      const today = dayjs().startOf("day");
                      if (current.isBefore(today, "day")) {
                        return true;
                      }

                      // disable before fromDate (if selected)
                      if (selectedFromDate) {
                        return current.isBefore(
                          selectedFromDate.startOf("day"),
                          "day"
                        );
                      }

                      return false;
                    }}
                    onChange={(date) => setSelectedToDate(date)}
                  />
                </Form.Item>
              </div>
            </Col>
          )}
          {!multipleDays && (
            <>
              <Col
                style={{
                  color: "rgba(44, 44, 44, 0.5)",
                }}
              >
                <FormattedMessage id="Common.From" />
              </Col>

              <Col>
                <div className="appoint-block-new">
                  <Form.Item
                    name="fromTime"
                    rules={[
                      {
                        required: true,
                        message: "Select a start time",
                      },
                      // {
                      //   validator: (_, value) => {
                      //     if (!value) {
                      //       return Promise.resolve();
                      //     }
                      //     const isToday = selectedFromDate
                      //       ? dayjs(selectedFromDate).isSame(now, "day")
                      //       : false;

                      //     if (isToday) {
                      //       const adjustedNow = now.subtract(15, "minutes");
                      //       if (value.isBefore(adjustedNow, "minute")) {
                      //         return Promise.reject(
                      //           new Error("Start time cannot be in the past.")
                      //         );
                      //       }
                      //     }
                      //     return Promise.resolve();
                      //   },
                      // },
                    ]}
                  >
                    <TimePicker
                      format="HH:mm"
                      minuteStep={60} // only whole hours
                      showNow={false}
                      variant="borderless"
                      allowClear={false}
                      hideDisabledOptions
                      prefix={<ClockCircleOutlined className="customicon" />}
                      suffixIcon={null}
                      disabledHours={() => {
                        const isToday = selectedFromDate
                          ? dayjs(selectedFromDate).isSame(dayjs(), "day")
                          : false;

                        const adjustedTime = now.subtract(15, "minutes");
                        const adjustedHour = adjustedTime.hour();

                        return [...Array(24).keys()].filter(
                          (hour) => isToday && hour < adjustedHour
                        );
                      }}
                      onChange={(time) => handleFromTimeChange(time)}
                    />
                  </Form.Item>
                </div>
              </Col>
            </>
          )}
          {!multipleDays && (
            <>
              <Col
                style={{
                  color: "rgba(44, 44, 44, 0.5)",
                }}
              >
                <FormattedMessage id="Common.To" />
              </Col>
              <div className="appoint-block-new">
                <Form.Item
                  name="toTime"
                  rules={[
                    {
                      required: true,
                      message: "Select an end time",
                    },
                    // {
                    //   validator: (_, value) => {
                    //     if (!value) {
                    //       return Promise.resolve();
                    //     }

                    //     const isToday = selectedFromDate
                    //       ? dayjs(selectedFromDate).isSame(dayjs(), "day")
                    //       : false;

                    //     const adjustedNow = dayjs().subtract(15, "minute");

                    //     if (isToday && value.isBefore(adjustedNow, "minute")) {
                    //       return Promise.reject(
                    //         new Error("End time cannot be in the past.")
                    //       );
                    //     }
                    //     const startTime = formLeave.getFieldValue("fromTime");
                    //     if (
                    //       startTime &&
                    //       value.isSameOrBefore(startTime, "minute")
                    //     ) {
                    //       return Promise.reject(
                    //         new Error("End time must be after start time.")
                    //       );
                    //     }

                    //     return Promise.resolve();
                    //   },
                    // },
                  ]}
                >
                  <TimePicker
                    format="HH:mm"
                    minuteStep={60} // only whole hours
                    showNow={false}
                    variant="borderless"
                    allowClear={false}
                    hideDisabledOptions
                    prefix={<ClockCircleOutlined className="customicon" />}
                    suffixIcon={null}
                    disabledHours={() => {
                      if (!selectedFromTime) {
                        return [];
                      }

                      const fromHour = selectedFromTime.hour();
                      return [...Array(24).keys()].filter(
                        (hour) => hour !== 0 && hour <= fromHour
                      );
                    }}
                    onChange={(time) => setSelectedEndTime(time)}
                  />
                </Form.Item>
              </div>
            </>
          )}
        </Row>
        <div className="breakline"></div>
        <Row gutter={32}>
          <Col span={24}>
            <Form.Item
              label={<FormattedMessage id="Appointment.TechnicianName" />}
              name="staffId"
              rules={[{ required: true, message: "Please select doctor" }]}
            >
              <Input disabled />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={32}>
          <Col span={24}>
            <Form.Item
              label={<FormattedMessage id="Appointment.Notes" />}
              name="notes"
            >
              <Input.TextArea showCount maxLength={200} />
            </Form.Item>
          </Col>
        </Row>
        <Row className="text-center">
          <Col span={24}>
            <Space>
              <Button
                key="cancel"
                onClick={() => props?.initialValues?.onCancel()}
              >
                <FormattedMessage id="Common.Cancel" />
              </Button>

              <Button key="send" type="primary" onClick={() => handleSubmit()}>
                <FormattedMessage id="Common.Submit" />
              </Button>
            </Space>
          </Col>
        </Row>
        {/* <Row className="text-center">
          <Col span={24}>
            <Space>
              {" "}
              <Button
                key="back"
                color="danger"
                variant="outlined"
                //onClick={handleCancel}
              >
                Cancel
              </Button>
              <Button
                key="submit"
                type="primary"
                //onClick={handleBlockSubmit}
              >
                Submit
              </Button>
            </Space>
          </Col>
        </Row> */}
      </Form>
      {/* <p style={{ color: "#E02424" }}>{errorMessage}</p> */}
    </div>
  );
};

export default ScheduleLeave;
